import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.isSingleSelect)
      ? (_openBlock(), _createBlock(_component_SingleSelect, {
          key: 0,
          slug: $props.slug,
          isSmallLabel: $props.isSmallLabel,
          filterValues: $props.filterValues,
          label: $props.title,
          onFilterChange: $options.onFilterChange
        }, null, 8 /* PROPS */, ["slug", "isSmallLabel", "filterValues", "label", "onFilterChange"]))
      : (_openBlock(), _createBlock(_component_MultiSelect, {
          key: 1,
          slug: $props.slug,
          isSmallLabel: $props.isSmallLabel,
          filterValues: $props.filterValues,
          label: $props.title,
          onFilterChange: $options.onFilterChange
        }, null, 8 /* PROPS */, ["slug", "isSmallLabel", "filterValues", "label", "onFilterChange"]))
  ]))
}